
import { Component, Prop, Vue } from "vue-property-decorator";
import RelaySchedule from "@/components/relays/RelaySchedule.vue";
import RelayExceptionalClosures from "@/components/relays/RelayExceptionalClosures.vue";
import UserListAvatar from "@/components/users/UserListAvatar.vue";
import SchedulePicker from "@/components/SchedulePicker.vue";
import RelayAddReferents from "@/components/relays/RelayAddReferents.vue";
import RelayAddGuests from "@/components/relays/RelayAddGuests.vue";
import RelayAddManagers from "@/components/relays/RelayAddManagers.vue";
import RelayEdit from "@/components/relays/RelayEdit.vue";
import AddressGeo from "@/components/AddressGeo.vue";
import { Getter } from "vuex-class";
import KeyActivity from "@/components/keys/KeyActivity.vue";

@Component({
  components: {
    KeyActivity,
    RelayAddReferents,
    SchedulePicker,
    UserListAvatar,
    AddressGeo,
    RelaySchedule,
    RelayExceptionalClosures,
    RelayAddGuests,
    RelayAddManagers,
    RelayEdit,
  },
})
export default class RelayInfo extends Vue {

  get hasEditRight(): boolean {
    return this.isReferent && (this.relay ? this.canDoInEnvCompany("EDIT_RELAY") : false);
  }


  get referents(): any[] {
    return this.relay.Referents?.filter((ref) => ref.id !== this.owner.id);
  }

  get owner(): any {
    return this.relay?.Referents?.find((ref) => ref.UserRelay.isOwner);
  }

  get isOwner(): boolean {
    return this.currentUser?.id === this.owner?.id;
  }

  get isReferent(): boolean {
    return this.relay?.Referents?.some((ref) => ref.id === this.currentUser?.id);
  }

  @Prop({ default: null })
  public relay: any;

  @Getter private envCompany: any;
  @Getter private currentUser: any;
  @Getter private canDoInEnvCompany: (right: string) => boolean;

  private displayEditDialog: boolean = false;
  private newInfo: any = null;

  private building: any = {};

  private mounted(): void {
    this.getBuilding();
  }

  private getBuilding(): void {
    this.$store.dispatch("buildings/getBuildingById", {
      buildingId: this.relay.buildingId,
    })
      .then((data) => {
        this.building = data;
      });
  }

  private async showEdit(): Promise<void> {
    this.displayEditDialog = true;
  }

  private addClosure(newClosure: any): void {
    this.newInfo = JSON.parse(JSON.stringify(this.relay));
    if (this.newInfo.exceptionalClosures?.items) {
      this.newInfo.exceptionalClosures.items.push(newClosure);
    } else {
      this.newInfo.exceptionalClosures = {
        items: [newClosure],
      };
    }
    this.$emit("update", this.newInfo);
    this.notifyExceptionalClosure(newClosure);
  }

  private notifyExceptionalClosure(newClosure: any): void {
    this.$store.dispatch("relays/notifyExceptionalClosure", {
      relayId: this.relay.id,
      exceptionalClosure: newClosure,
    }).then((res) => {
      this.$store.commit("alerts/displaySuccess", {
        msg: this.$i18n?.t("actions.saved"),
      });
    }).catch((err) => {
      this.$store.commit("alerts/displayError", {
        msg: err,
      });
    });
  }

  private removeClosure(oldClosure: any): void {
    this.newInfo = JSON.parse(JSON.stringify(this.relay));
    if (this.newInfo.exceptionalClosures?.items) {
      this.newInfo.exceptionalClosures.items = this.newInfo.exceptionalClosures.items
        .filter((closure) => closure.startDate !== oldClosure.startDate
          && closure.endDate !== oldClosure.endDate);
      this.$emit("update", this.newInfo);
    }
  }

  private reset() {
    this.displayEditDialog = false;
    this.$emit("update", this.newInfo);
  }


}
